<template>
<v-container class="fill-height data-container" fluid>

    <v-form ref="thresholdForm" :lazy-validation="false" v-model="$props.threshold.formValid">
        <v-row>
            <v-col cols="12" md="6" xl="4">
                <v-autocomplete label="Report" color="#c42111" v-model="$props.threshold.thres_obj" :items="$props.thresholdResources.reports" item-text="name" return-object @change="reportChange" :rules="[validation.required($props.threshold.thres_obj, 'Threshold Report')]" />
            </v-col>
            <v-col cols="12" md="6" xl="4">
                <v-autocomplete label="Metric" color="#c42111" v-model="$props.threshold.thres_column" :items="metricsList" :rules="[validation.required($props.threshold.thres_column, 'Metric')]"/>
            </v-col>
            <v-col cols="12" md="6" xl="4">
                <v-autocomplete label="Threshold" color="#c42111" v-model="$props.threshold.thres_test" :items="conditionsList" :rules="[validation.required($props.threshold.thres_test, 'Threshold')]"/>
            </v-col>
            <v-col cols="12" md="6" xl="4">
                <v-text-field label="Value" type="number" color="#c42111" v-model="$props.threshold.thres_value" :rules="[validation.required($props.threshold.thres_value, 'Value')]" />
            </v-col>


            <v-col cols="12">
                <span style="display: block; margin-bottom: 1em;">User Threshold Criteria</span>
                <v-list style="margin-bottom: 1em; border: #ffffff1f 1px solid;" color="#303030">

                    <template v-for="(criteria, index) in $props.threshold.thres_criteria">
                        <v-list-item :key="index">

                            <template v-if="editCriteria != index">
                                <v-list-item-action style="display: inline-block;">
                                    <v-btn style="margin-right: 1em;" fab dark x-small color="#c42111" @click="editCriteria = index" ><v-icon dark>mdi-pencil</v-icon></v-btn>
                                    <v-btn fab dark x-small color="#c42111" @click="deleteCriteria(index)"><v-icon dark>mdi-delete</v-icon></v-btn>
                                </v-list-item-action>
                                <span v-text="criteriaText(criteria)" />
                            </template>

                            <template v-if="editCriteria == index">
                                <v-list-item-action style="display: inline-block;">
                                <v-btn fab dark x-small color="#c42111" @click="editCriteria = -1" ><v-icon dark>mdi-check</v-icon></v-btn>
                                </v-list-item-action>
                                <v-col>
                                    <v-autocomplete label="Metric" color="#c42111" :items="metricsList" :value="getCriteriaValue(criteria).metric" @change="setCriteriaValue($event, 0, index) "/>
                                </v-col>
                                <v-col>
                                    <v-autocomplete label="Threshold" color="#c42111" :items="conditionsList" :value="getCriteriaValue(criteria).condition" @change="setCriteriaValue($event, 1, index)" />
                                </v-col>
                                <v-col>
                                    <v-text-field label="Value" type="number" color="#c42111" :value="getCriteriaValue(criteria).value" @change="setCriteriaValue($event, 2, index)" />
                                </v-col>
                            </template>

                        </v-list-item>
                        <v-divider :key="`divider-${index}`"></v-divider>
                    </template>

                    <v-btn class="ml-6 mt-3 mb-1" color="#c42111" @click="addCriteria">Add Criteria</v-btn>
                </v-list>
            </v-col>


            <v-col cols="12" md="6" xl="4">
                <v-select label="Severity" color="#c42111" v-model="$props.threshold.thres_severity" :items="$props.thresholdResources.severities" :rules="[validation.required($props.threshold.thres_severity, 'Severity')]"/>
            </v-col>

            <v-col cols="12" md="6" xl="4">
                <v-text-field label="Hours Start" color="#c42111" v-model="$props.threshold.thres_hour_begin" :rules="[validation.integer($props.threshold.thres_hour_begin, 'Hours')]"/>
            </v-col>
            <v-col cols="12" md="6" xl="4">
                <v-text-field label="up to and including" color="#c42111" v-model="$props.threshold.thres_hour_end" :rules="[validation.integer($props.threshold.thres_hour_end, 'Hours')]"/>
            </v-col>
            <v-col cols="12">
                <days-of-week :threshold="threshold"></days-of-week>
            </v-col>
        </v-row>
    </v-form>

</v-container>
</template>

<script>
import DaysOfWeek from '@/components/UserThresholds/DaysOfWeek';
export default {
    name: 'ThresholdProfileThresholdEdit',
    props: ['thresholdResources', 'threshold', 'thresholdProfile', 'lockSave'],
    components: {
        DaysOfWeek
    },

    data: () => ({
        editCriteria: -1,
        selectedReport: {},
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            integer: (value, fieldName) => (!isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10))) || `${fieldName} must be integers`
        }
    }),

    computed: {
        metricsList() {
            return this.$props.threshold.thres_obj.columns.map((item, index) => ({
            value: index,
            text: item
            }));
        },

        conditionsList() {
            return this.$props.thresholdResources.conditions.map((item, index) => ({
            value: index,
            text: item
            }));
        },
    },

    methods: {
        reportChange: function(val) {
            this.$props.threshold.thres_column = '';
            this.$props.threshold.thres_test = '';
            this.$props.threshold.thres_value = '';
            this.$props.threshold.thres_severity = '';
            this.$props.threshold.thres_criteria = [];
            this.$props.threshold.user_obj_id = val.id;
        },

        deleteCriteria: function(criteriaIndex) {
            this.$props.threshold.thres_criteria.splice(criteriaIndex, 1);
        },

        addCriteria: function() {
            this.$props.threshold.thres_criteria.push('0 0 0');
        },

        criteriaText: function(criteria) {
            let criteriaAnswer = "";
            const criteriaArray = criteria.split(' ');
            criteriaAnswer += `${this.$props.threshold.thres_obj.columns[criteriaArray[0]]} `;
            criteriaAnswer += `${this.$props.thresholdResources.conditions[criteriaArray[1]]} `;
            criteriaAnswer += `${criteriaArray[2]}`;
            return criteriaAnswer;
        },

        getCriteriaValue: function(criteria) {
            const criteriaArray = criteria.split(' ');
            return {
            metric: this.metricsList[criteriaArray[0]],
            condition: this.conditionsList[criteriaArray[1]],
            value: criteriaArray[2]
            }
        },

        setCriteriaValue: function(e, type, criteriaIndex) {
            const criteriaArray = this.$props.threshold.thres_criteria[criteriaIndex].split(' ');
            criteriaArray[type] = e;
            let newValue = criteriaArray.join(' ');
            this.$props.threshold.thres_criteria[criteriaIndex] = newValue;
        },
    },

    mounted() {

    },

    watch: {
        threshold: {
            handler(newVal, oldVal) {
                if(!this.$props.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
            },
            deep: true
        }
    },


};
</script>

<style scoped>

    .data-container {
        padding: 0;
    }

</style>
